import { type SvgIconComponent } from "@mui/icons-material";
import { EmptyBlock } from "@/features/reassistRequests/components/StateBlocks";

interface Props {
  icon: SvgIconComponent;
  title: string;
  description?: string;
  /** 小さめ表示（詳細ダイアログ内）。 */
  compact?: boolean;
}

/** 空状態。/reassist と同じ型（方針書 2-7：破線の枠、40px のアイコン、16px の太字の1文、14px の補足）。 */
export const SaleEmptyState: React.FC<Props> = ({
  icon,
  title,
  description,
  compact = false,
}) => (
  <EmptyBlock
    icon={icon}
    title={title}
    description={description}
    compact={compact}
  />
);
